import { defineComponent as _defineComponent } from 'vue'
import '@/components/pages/workspace/WorkspaceEditPage/GroupsPermissionManager.scss';

import SelectRoleDialog from '@/components/layout/dialogs/SelectRoleDialog.vue';
import FindGroupDialog from '@/components/layout/dialogs/FindGroupDialog.vue';

import store from '@/store';
import notificationService from '@/services/NotificationService';
import apiService from '@/services/ApiService';
import authService from '@/services/AuthService';

import { computed, onMounted, ref } from 'vue';
import { Workspace } from '@/models/Workspace';
import { Group } from '@/models/Group';
import { Role } from '@/models/Role';


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupsPermissionManager',
  props: {
    workspace: null,
    groups: null
  },
  emits: ["reload"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'reload'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  workspace: Workspace;
  groups: Group[];
}





const findGroupDialogVisible = ref(false);
const roleDialogGroup = ref<Group>(null);
const groupsExist = ref(true);
const currentWorkspace = ref<Workspace>(props.workspace);

const isAdmin = computed((): boolean => !(store.state.user.role === Role.USER));

const handleRemoveGroup = async (group: Group) => {
  try {
    await apiService.workspace.groupRoles.delete(props.workspace.id, group.id);
    const index = props.groups.indexOf(group);
    if (index >= 0) {
      currentWorkspace.value.groups.groups.splice(index, 1);
    }

    notificationService.success(`The group ${splitGroupName(group.title)} has been successfully removed`);
    emit('reload');
  } catch (res) {
    apiService.handleResponseError(res);
  }
};

const handleAddGroup = async (groups: string[]) => {
  findGroupDialogVisible.value = false;
  if (!groups.length) return;

  try {
    const promisesAddGroups = groups.map(async (groupId: string) => confirmAddGroup(groupId));

    await Promise.all(promisesAddGroups);

    notificationService.success('Group was successfully created!');
    emit('reload');
  } catch (err) {
    apiService.handleResponseError(err);
  }
};

const confirmAddGroup = (groupId: string) => {
  return apiService.workspace.groupRoles.create(props.workspace.id, groupId, Role.VIEWER);
};

const handleSaveGroupRole = (role: string, group: Group) => updateGroupRole(group, role);

const updateGroupRole = async (group: Group, role: string) => {
  try {
    await apiService.workspace.groupRoles.create(props.workspace.id, group.id, role);
    group.role = role;
  } catch (res) {
    apiService.handleResponseError(res);
  }
};

const checkWorkspaceGroupExists = async () => {
  const groups = await apiService.groups.all();
  groupsExist.value = !!groups.data.groups.length;
};

const splitGroupName = (groupName: string): string => {
  if (groupName.length > 30) return groupName.substring(0, 30) + '...';
  return groupName;
};

onMounted(async () => {
  const isUserActive = await authService.isUserActive();

  if (!isUserActive) {
    return;
  }
  await checkWorkspaceGroupExists();
});

return { __sfc: true,props, emit, findGroupDialogVisible, roleDialogGroup, groupsExist, currentWorkspace, isAdmin, handleRemoveGroup, handleAddGroup, confirmAddGroup, handleSaveGroupRole, updateGroupRole, checkWorkspaceGroupExists, splitGroupName, SelectRoleDialog, FindGroupDialog }
}

})